//
// RangeAttributesMapEntry.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../../GTLModel";
import "./RangeAttributesMapEntryType";
import "./RangeBound";
import "./RangeEntryAttributes";

var RangeAttributesMapEntry = createModule("gtl::RangeAttributesMapEntry", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        minValue: 1,
        minLabel: 7,
        maxValue: 1,
        attributes: 1,
        label: 7,
        type: 4,
        maxLabel: 7,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_ooo: [4,1,1,1],
        _create_o: [4,1],
    },
    ,
    ["_create"]
]);
export default RangeAttributesMapEntry;
